import { render, staticRenderFns } from "./RepaymentsTable.vue?vue&type=template&id=35e0624a"
import script from "./RepaymentsTable.vue?vue&type=script&lang=js"
export * from "./RepaymentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports